import { createContext, useContext } from "react";

import type { UserPreference } from "../components/Menu-Related/filters";

export type ActionTrackingCtx = {
  trackDishSelected: (dishId: string) => void; // When a dish is selected and the details drawer is opened.
  trackViewMenu: () => void; // When View Menu button of the filter selection is clicked.
  trackNewPreference: (userPreference: UserPreference) => void; // When a new preference is selected.
};

const NoOpTracker: ActionTrackingCtx = {
  trackDishSelected: () => {},
  trackViewMenu: () => {},
  trackNewPreference: () => {},
};

const ActionTrackingContext = createContext<ActionTrackingCtx>(NoOpTracker);

export const ActionTrackingProvider = ActionTrackingContext.Provider;
export const useActionTracking = () => useContext(ActionTrackingContext);
